import React from 'react';
import { useModal } from 'hooks/useModal';
import { DividendProps } from 'pages/DividendPrediction';
import { convertToDisplayDividendList } from 'pages/DividendDetailPrediction';
import { DividendPieChart, DividendPieChartNoData } from './DividendChart';
import { DividendSymbolList } from './DividendSymbolList';
import { DividendPredictionLoading } from './DividendError';
import { DividendPredictionModal as DividendModal } from '../modal/DividendPredictionModal';

export const DividendPredictionModal = () => {
  const [isShowModal, { hideModal, showModal }] = useModal();
  return (
    <>
      <div className="flex flex-row mt-3">
        <div
          className="flex flex-row items-center mr-4 ml-auto text-bluegray-500 rounded-lg cursor-pointer"
          onClick={showModal}>
          <div className="text-sm mr-1">予想データについて</div>
          <div className="icon-info text-bluegray-400"></div>
        </div>
      </div>
      <DividendModal
        {...{
          isShow: isShowModal,
          hide: hideModal,
        }}
      />
    </>
  );
};

export type UnreleasedStatusProps = 'all' | 'not_all' | 'not_exist';
export type DividendListItemProps = Omit<DividendProps, 'unreleased'> & {
  unreleasedStatus: UnreleasedStatusProps;
};
export type DividendListProps = {
  symbol: string;
  symbolName: string;
  totalQty: number;
  items: DividendListItemProps[];
};

// 内訳
export const DividendClassification = ({
  dividendData,
  selectedDate,
  totalDividend,
  isTaxDeduction,
}: {
  dividendData: DividendProps[];
  selectedDate: string;
  totalDividend: number;
  isTaxDeduction: boolean;
}) => {
  const displayDividendList = convertToDisplayDividendList(
    dividendData,
    isTaxDeduction
  );

  if (displayDividendList === null)
    return <DividendPredictionLoading str={'銘柄'} />;

  return (
    <>
      <div className="my-2 mx-1">
        {displayDividendList.length === 0 ? (
          <DividendPieChartNoData />
        ) : (
          <DividendPieChart
            {...{
              dividendList: displayDividendList,
              selectedDate,
              isTaxDeduction,
            }}
          />
        )}
      </div>
      <div className="mx-4 text-sm text-bluegray-550">
        ※ 未発表は過去データを元に算出
      </div>
      <DividendPredictionModal />
      <DividendSymbolList
        {...{
          dividendList: displayDividendList,
          totalDividend,
          isTaxDeduction,
        }}
      />
    </>
  );
};
